import axios from "axios"

const saveRegionApiMg = async (regionGeoJson) => {
  const res = await axios.post(
    `${process.env.REACT_APP_URL_MG_API}region`,
    regionGeoJson
  );
  const data = await res.data;
  return {data, res}
}

export default saveRegionApiMg